export default __webpack_public_path__ + "static/media/avatar8.b25b946c.jpg";